import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Service icon — rounded rectangle service card with 3 horizontal lines.
 *
 * Dual-tone layered style:
 * - Rounded rect outline in currentColor
 * - Cyan accent fill at 10% on the rect body
 * - 3 horizontal lines inside (representing service content)
 * - No node dots
 */
export const ServiceIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Accent fill on the rect body */}
    <rect
      x="3"
      y="4"
      width="18"
      height="16"
      rx="3"
      fill="#00d4ff"
      fillOpacity={0.1}
    />
    {/* Rect outline */}
    <rect
      x="3"
      y="4"
      width="18"
      height="16"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* 3 horizontal lines inside */}
    <path
      d="M7 9 H17 M7 12 H17 M7 15 H13"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

ServiceIcon.displayName = "ServiceIcon";

export default ServiceIcon;
